module.exports = __webpack_public_path__ + "img/marathon_logo_ru.413b24da.svg";